import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useNotifications } from '../../../providers/notificationProvider/NotificationProvider';
import { GET_SELECTED_SHOP_ID, REQUEST } from '../../js/Const';
import { GetCookie } from '../../js/request';

export const useNotificationsUpdater = () => {
    const location = useLocation();
    const { setNotification } = useNotifications();

    useEffect(() => {
        const fetchCount = async () => {
            const selectedId = GET_SELECTED_SHOP_ID();
            const accessToken = GetCookie("access_token");

            if (selectedId === 0 || !accessToken) return;

            try {
                const response = await fetch(
                    `${REQUEST}/api/v1/products_offers/count?shops_id=${selectedId}`,
                    {
                        method: "GET",
                        headers: {
                            "Accept": "application/json",
                            "Access-Token": accessToken,
                        },
                    }
                );

                if (response.ok) {
                    const data = await response.json();
                    const count = data.data?.count_product_offers || 0;
                    setNotification('productOffers', count);
                }
            } catch (error) {
                console.error('Error fetching notifications count:', error);
            }
        };

        fetchCount();
    }, [location.pathname, setNotification]);
};